import type { FunctionComponent } from 'react'
import React from 'react'

import { Icon } from '../../Icon'
import type { Icon as IconProps } from '../../Icon/Icon'
import styles from '../Icons.module.scss'

export const RouterWifiIcon: FunctionComponent<IconProps> = ({
  fill,
  width = 68,
  height = 34,
  ...rest
}) => {
  return (
    <Icon
      data-testid="needs-based-filter-icon-routerWifi"
      fill={fill}
      height={height}
      viewBox={`0 0 ${width} ${height}`}
      width={width}
      {...rest}
    >
      <g fill="none" fillRule="evenodd">
        <polygon fill="#ffffff" className={styles.white} opacity="0" points="0 34 68 34 68 0 0 0" />
        <path
          d="M48,25 L20,25 C18.8957153,25 18,25.8957153 18,27 L18,31 C18,32.1042847 18.8957153,33 20,33 L48,33 C49.1042847,33 50,32.1042847 50,31 L50,27 C50,25.8957153 49.1042847,25 48,25 Z M20,27 L48,27 L48,31 L20,31 L20,27 Z"
          fill="#00000"
          className={styles.defaultColor}
          fillRule="nonzero"
        />
        <path
          d="M23 29C23 29.552 22.552 30 22 30 21.448 30 21 29.552 21 29 21 28.448 21.448 28 22 28 22.552 28 23 28.448 23 29M26 29C26 29.552 25.552 30 25 30 24.448 30 24 29.552 24 29 24 28.448 24.448 28 25 28 25.552 28 26 28.448 26 29M29 29C29 29.552 28.552 30 28 30 27.448 30 27 29.552 27 29 27 28.448 27.448 28 28 28 28.552 28 29 28.448 29 29M45 30 32 30C31.448 30 31 29.552 31 29L31 29C31 28.448 31.448 28 32 28L45 28C45.552 28 46 28.448 46 29L46 29C46 29.552 45.552 30 45 30"
          fill="#00000"
          className={styles.defaultColor}
        />
        <path
          d="M42.7071,18.7071 C45.2801,16.5431 47.0001,13.4071 47.0001,10.0001 C47.0001,6.5931 45.2801,3.4571 42.7071,1.2931 C41.7281,0.4691 40.3061,1.8771 41.2931,2.7071 C43.4751,4.5421 45.0001,7.0891 45.0001,10.0001 C45.0001,12.9111 43.4751,15.4571 41.2931,17.2931 C40.3071,18.1221 41.7281,19.5311 42.7071,18.7071"
          fill="#0050B3"
          className={styles.interactiveColor}
        />
        <path
          d="M40.7071 14.7071C42.0891 13.5401 43.0001 11.8301 43.0001 10.0001 43.0001 8.1701 42.0891 6.4601 40.7071 5.2931 40.2951 4.9451 39.6971 4.8881 39.2931 5.2931 38.9351 5.6501 38.8781 6.3571 39.2931 6.7071 39.8781 7.2011 40.2731 7.6541 40.6121 8.3271 40.8611 8.8231 41.0001 9.4341 41.0001 10.0001 41.0001 10.1551 40.9901 10.3101 40.9771 10.4651 40.9691 10.5361 40.9701 10.5341 40.9801 10.4561L40.9631 10.5591C40.9461 10.6441 40.9301 10.7301 40.9101 10.8141 40.8311 11.1531 40.7431 11.4061 40.6361 11.6241 40.2961 12.3201 39.8921 12.7871 39.2931 13.2931 38.8801 13.6411 38.9341 14.3481 39.2931 14.7071 39.7021 15.1161 40.2931 15.0571 40.7071 14.7071M26.7071 17.2929C24.5241 15.4579 23.0001 12.9109 23.0001 9.9999 23.0001 7.0889 24.5241 4.5429 26.7071 2.7069 27.6931 1.8779 26.2721.4689 25.2931 1.2929 22.7201 3.4569 21.0001 6.5929 21.0001 9.9999 21.0001 13.4069 22.7201 16.5429 25.2931 18.7069 26.2721 19.5309 27.6941 18.1229 26.7071 17.2929"
          fill="#0050B3"
          className={styles.interactiveColor}
        />
        <path
          d="M28.7071,13.2929 C28.1221,12.7989 27.7261,12.3459 27.3881,11.6729 C27.1391,11.1769 27.0001,10.5659 27.0001,9.9999 C27.0001,9.8449 27.0091,9.6899 27.0231,9.5349 C27.0311,9.4639 27.0301,9.4659 27.0201,9.5439 C27.0251,9.5089 27.0311,9.4749 27.0371,9.4409 C27.0541,9.3559 27.0701,9.2699 27.0891,9.1859 C27.1681,8.8469 27.2571,8.5939 27.3631,8.3759 C27.7041,7.6799 28.1081,7.2129 28.7071,6.7069 C29.1201,6.3589 29.0661,5.6519 28.7071,5.2929 C28.2981,4.8839 27.7071,4.9429 27.2931,5.2929 C25.9111,6.4599 25.0001,8.1699 25.0001,9.9999 C25.0001,11.8299 25.9111,13.5399 27.2931,14.7069 C27.7051,15.0549 28.3031,15.1119 28.7071,14.7069 C29.0641,14.3499 29.1221,13.6429 28.7071,13.2929"
          fill="#0050B3"
          className={styles.interactiveColor}
        />
        <path
          d="M34,12 C34.5128358,12 34.9355072,12.3860402 34.9932723,12.8833789 L35,13 L35,26 C35,26.5522847 34.5522847,27 34,27 C33.4871642,27 33.0644928,26.6139598 33.0067277,26.1166211 L33,26 L33,13 C33,12.4477153 33.4477153,12 34,12 Z"
          fill="#00000"
          className={styles.defaultColor}
          fillRule="nonzero"
        />
        <path
          d="M34,7 C32.3427153,7 31,8.34271525 31,10 C31,11.6572847 32.3427153,13 34,13 C35.6572847,13 37,11.6572847 37,10 C37,8.34271525 35.6572847,7 34,7 Z M34,9 C34.5527153,9 35,9.44728475 35,10 C35,10.5527153 34.5527153,11 34,11 C33.4472847,11 33,10.5527153 33,10 C33,9.44728475 33.4472847,9 34,9 Z"
          fill="#00000"
          className={styles.defaultColor}
          fillRule="nonzero"
        />
      </g>
    </Icon>
  )
}
